const API_URL = import.meta.env.VITE_API_URL || '/api';

async function request(endpoint, options = {}) {
  const url = `${API_URL}${endpoint}`;

  const config = {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  };

  const response = await fetch(url, config);

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Erreur réseau' }));
    throw new Error(error.error || `Erreur ${response.status}`);
  }

  return response.json();
}

function authHeaders(token) {
  return { Authorization: `Bearer ${token}` };
}

// Public endpoints
export const api = {
  getTournaments: () => request('/tournaments'),
  getNonCircuitTournaments: () => request('/tournaments/non-circuit'),
  getTournament: (id) => request(`/tournaments/${id}`),
  getRankings: () => request('/rankings'),
  getInvitationalSettings: () => request('/rankings/invitational'),
  getPokemonUsage: () => request('/analytics/pokemon'),
  getPalmares: () => request('/palmares'),
  getHealth: () => request('/health'),
};

// Admin endpoints (require auth token)
export const adminApi = {
  getAllTournaments: (token) =>
    request('/admin/tournaments', {
      headers: authHeaders(token),
    }),

  createTournament: (token, data) =>
    request('/admin/tournaments', {
      method: 'POST',
      headers: authHeaders(token),
      body: JSON.stringify(data),
    }),

  deleteTournament: (token, id) =>
    request(`/admin/tournaments/${id}`, {
      method: 'DELETE',
      headers: authHeaders(token),
    }),

  // Non-circuit tournaments
  getAllNonCircuitTournaments: (token) =>
    request('/admin/non-circuit-tournaments', {
      headers: authHeaders(token),
    }),

  createNonCircuitTournament: (token, data) =>
    request('/admin/non-circuit-tournaments', {
      method: 'POST',
      headers: authHeaders(token),
      body: JSON.stringify(data),
    }),

  deleteNonCircuitTournament: (token, id) =>
    request(`/admin/non-circuit-tournaments/${id}`, {
      method: 'DELETE',
      headers: authHeaders(token),
    }),

  // Palmarès
  createPalmaresEntry: (token, data) =>
    request('/admin/palmares', {
      method: 'POST',
      headers: authHeaders(token),
      body: JSON.stringify(data),
    }),

  deletePalmaresEntry: (token, id) =>
    request(`/admin/palmares/${id}`, {
      method: 'DELETE',
      headers: authHeaders(token),
    }),

  recalculateRankings: (token) =>
    request('/admin/rankings/recalculate', {
      method: 'POST',
      headers: authHeaders(token),
    }),

  refreshAnalytics: (token) =>
    request('/admin/analytics/refresh', {
      method: 'POST',
      headers: authHeaders(token),
    }),

  clearCache: (token) =>
    request('/admin/cache', {
      method: 'DELETE',
      headers: authHeaders(token),
    }),

  getInvitationalSettings: (token) =>
    request('/admin/invitational', {
      headers: authHeaders(token),
    }),

  updateInvitationalSettings: (token, settings) =>
    request('/admin/invitational', {
      method: 'PUT',
      headers: authHeaders(token),
      body: JSON.stringify(settings),
    }),
};
